import React, { Component } from 'react'
import { translate } from "react-i18next"
//import './text.css'

class InputText extends Component {
  constructor(props){
    super(props)

    this.state = {
      inputText: (props.value !== null && props.value !== undefined) ? props.value : '',
      error: false
    }

    this.handleKeyDown = this.handleKeyDown.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.validate = this.validate.bind(this)
  }

  componentWillReceiveProps(nextProps){
    const { value } = nextProps
    this.setState({
      inputText: (value !== null && value !== undefined) ? value : ''
    })
    if(document.hasFocus()) {
      this.input.focus()
    }
  }
  componentDidMount(){
    if(document.hasFocus()) {
      this.input.focus()
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if(document.hasFocus()) {
      this.input.focus()
    }
  }

  handleSubmit(){
    if(this.props.onSubmit && this.validate()){
      this.props.onSubmit(this.state.inputText.trim())
    } else {
      this.setState({ error: true })
      setTimeout(() => { this.setState({ error: false }) }, 500)
    }
  }

  validate(){
    const { inputText } = this.state
    const { required, regex } = this.props

    if( inputText.length === 0 ) {
      return !required
    }

    if(regex && !regex.test(inputText)) {
      return false
    }

    return true
  }

  handleInputChange(e){
    this.setState({ inputText: e.target.value })
  }

  handleKeyDown(e){
    if( e.keyCode === 13 ) { // Enter
      e.preventDefault()
      this.handleSubmit()
    }
  }

  render() {
    let {id, color } = this.props

    return (
      <div className="booking-input booking-input-text inside-button">
        <div className={`booking-input-wrapper ${ this.state.error ? 'shake' : '' }`}>
          <input ref={input => this.input = input} type="text" id={id} name={id} onChange={this.handleInputChange} onKeyDown={this.handleKeyDown} value={this.state.inputText} />
          <button onClick={this.handleSubmit} style={{ backgroundColor: color }}>{this.props.okButtonLabel}</button>
        </div>
      </div>
    );
  }
}

export default translate("translations")(InputText)
